import { updateSearchCount, updateSelectedFilters, drawSearchResult } from "./update-views";
import { setEventInsideResponseFilter } from "./filters";
import { updatePagination } from "./pagination"
import { getUniqueParams, updateBrowserURL } from "../updateURL";


export function performSearch(pageNumber = 1, formControl, currentAbortController, additionalTag = "") {
    if (currentAbortController) {
        currentAbortController.abort();
    }

    currentAbortController = new AbortController();

    const formData = new FormData(formControl);

    formData.set('pageNumber', pageNumber);

    if (additionalTag.length > 0) {
        formData.append('tagSelection', additionalTag);
    }

    const searchParams = getUniqueParams(new URLSearchParams(formData)).toString();

    fetch(`/Umbraco/Api/MetadataCatalogueSearchResults/PerformSearch?${searchParams}`, { signal: currentAbortController.signal })
        .then(response => response.json())
        .then(data => {
            updateSearchCount(data.filterSearchResult.totalResultCount);
            updateSelectedFilters(data.orgCleanNormalized, data.tagCleanNormalized, data.accessCleanNormalized, formControl, currentAbortController);
            drawSearchResult(data.filterSearchResult.result, formData);
            updatePagination(data.pagination, formControl, currentAbortController);

            currentAbortController = null;
        })
        .then(()=>{
            const tagsInResponse = document.getElementsByClassName("js-in-response-filter");
            setEventInsideResponseFilter(tagsInResponse, formControl, currentAbortController);

            updateBrowserURL(formControl, additionalTag);
        })
        .catch(error => {
            if (error.name !== "AbortError") {
                console.log('Error drawing the search results:', error)
            }
        });
}